// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const year = new Date().getFullYear();

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Besoin d'aide? \n Consultez notre documentation.`,
    documentation: `documentation`,
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  product: `produit`,
  invoice: `facture`,
  details: `détail`,
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `niveau menu 1`,
  menu_level_2a: `niveau menu 2a`,
  menu_level_2b: `niveau menu 2b`,
  menu_level_3a: `niveau menu 3a`,
  menu_level_3b: `niveau menu 3b`,
  menu_level_4a: `niveau menu 4a`,
  menu_level_4b: `niveau menu 4b`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  item_external_link: `lien externe de l'article`,
  description: `la description`,
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  header: {
    about: "À propos",
    contact: "Contact",
    pricing: "Tarification",
    ReportAbuse: "Signaler un abus",
    InvitationSystem: "Système d'invitation",
    verify_email: "Vérifier l'e-mail",
    sign_in: "Se connecter",
    dashboard: "Tableau de bord",
    biolink_page: "Page Biolink",
    admin: "Admin",
    logout: "Se déconnecter",
    sign_up: "S'inscrire",
    about_us: "À propos de nous",
    name: "Daniel Jones",
    post: "PDG et fondateur",
    contact_us: "Contactez-nous",
    payments_list: "Liste des paiements",
  },
  footer: {
    terms_conditions: "Conditions générales",
    privacy_policy: "Politique de confidentialité",
    copyright: "Droits d'auteur © " + year + " bil.bio",
    Update_cookies_preferences: "Gérer les cookies",
  },
  biolink_title: {
    edit: "Modifier",
    delete: "Supprimer",
    delete_cap: "SUPPRIMER",
    save_cap: "ENREGISTRER",
    view: "Voir",
    settings: "Paramètres",
    duplicate: "Dupliquer",
    your_link_is: "Votre lien est",
    copy_to_clipboard: "Copier dans le presse-papiers",
    copied: "Copié",
    change_status: "Changer de statut",
    edit_user: "Modifier l'utilisateur",
    block: "Bloquer",
    november: "Novembre",
    maximum: "Maximum",
  },
  auth: {
    create_your_account: "Créer votre compte",
    signup_to_bilbio_and_create_your_biolink_now:
      "Inscrivez-vous à bilbio et créez votre Biolink MAINTENANT !",
    pagename: "Nom de la page",
    enter_page_name: "Entrer le nom de la page",
    enter_page_email: "Entrer l'adresse e-mail",
    by_creating_an_account_you_agreeing_to_our:
      "En créant un compte, vous acceptez nos",
    log_in: "CONNEXION",
    create_account: "CRÉER UN COMPTE",
    hi_welcome_back: "Salut, Bienvenue de retour !",
    enter_you_details_to_login_into_your_bilbio_account:
      "Entrez vos détails pour vous connecter à votre compte bilbio",
    enter_password: "Entrer le mot de passe",
    login: "CONNEXION",
    sign_up: "S'INSCRIRE",
    do_not_have_an_account: "Vous n'avez pas de compte ?",
    page_name_required: "Nom de la page requis",
    pass_required: "Mot de passe requis",
    this_username_is_already_taken: "Ce nom d'utilisateur est déjà pris",
    page_name_cannot_contain_symbols:
      "Le nom de la page ne peut pas contenir de symboles",
    forgot_your_password: "Mot de passe oublié",
  },
  Invitation_System: {
    More_than_a_todo_app: "Plus qu'une application de liste de tâches",
    paragraph:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit quam eum facere explicabo, dolorum sed consequuntur incidunt, culpa cum voluptatem, eaque consectetur saepe rerum dolor? Cum eius labore debitis minus.",
    thanks_for_siging: "Merci de vous être inscrit",
    verify_your_email: "Vérifiez votre e-mail",
    confirm_email:
      "Veuillez confirmer que vous souhaitez utiliser ceci comme votre adresse e-mail",
    verify_email: "VÉRIFIER L'EMAIL",
    bilbio_Account_activated: "Compte Bill Bio activé",
    hello: "Bonjour John",
    email_verified:
      "Merci, Votre e-mail a été vérifié. Votre compte est maintenant actif.",
    link_login_account:
      "Veuillez utiliser ce lien ci-dessous pour vous connecter à votre compte",
    login_account: "CONNEXION AU COMPTE",
    invite_friend: "Inviter un ami",
    invite_friend_cap: "INVITER UN AMI",
    you_have: "Vous avez",
    credits: "crédits",
    friend: "Ami",
    sent: "envoyé",
  },
  front_end_pages: {
    home_page: {
      hero_section: {
        main_title_part_one: "Créez un seul lien",
        main_title_part_two: "pour tous tes liens",
        sub_title:
          "Utilisez diverses plateformes en ligne pour interagir avec des individus partageant les mêmes idées, gagner en visibilité et établir une présence numérique pour vos efforts créatifs, le tout depuis votre seul biolink. ",
      },
      features_section: {
        biolink: "Biolink",
        create: "CRÉER",
        create_your: "Créez votre",
        unique: "unique",
        sec_one_first_line:
          "Générez votre page de lien personnalisée en quelques secondes seulement.",
        sec_one_sec_line:
          "Unifiez l'ensemble de votre présence en ligne en un seul lien.",
        sec_one_thired_line: "Un lien pour partager tout avec vos abonnés.",
        sec_one_four_line:
          "Personnalisez vos biolinks, gardez-les courts et percutants, et plus faciles à partager.",
        customize: "PERSONNALISER",
        design: "Design",
        exceptional: "exceptionnel",
        sec_two_first_line:
          "Créez votre propre page de lien bio unique et hautement personnalisable en toute simplicité.",
        sec_two_sec_line:
          "Personnalisez votre biolink avec des couleurs et un branding personnalisés.",
        sec_two_thired_line:
          "L'expérience est facilitée avec plusieurs composants prêts à l'emploi.",
        sec_two_four_line:
          "Ajoutez vos poignées de médias sociaux Instagram, Twitter, Snapchat, TikTok, Youtube, des images et plus encore.",
        share: "PARTAGER",
        add_your_biolink_to_your: "Ajoutez votre Biolink à votre",
        social_media: "médias sociaux",
        handles: "poignées",
        sec_thered_first_line:
          "Ajoutez votre URL biobil personnalisée à toutes les plateformes pour atteindre votre public.",
        sec_thered_sec_line:
          "Personnalisez votre biolink avec des couleurs et un branding personnalisés.",
        sec_thered_thired_line:
          "L'expérience est facilitée avec plusieurs composants prêts à l'emploi.",
        sec_thered_four_line: "Ajoutez du branding et une optimisation SEO.",
      },
      pricing_section: {
        subscription: "ABONNEMENT",
        choose_a: "Choisissez un",
        plan: "plan",
        that_works_for_you: "qui vous convient",
        monthly: "Mensuel",
        annual: "Annuel",
        what_included: "Ce qui est inclus",
        unlimited_biolink_pages: "Pages Biolink illimitées",
        unlimited_biolink_blocks: "Blocs Biolink illimités",
        bio_pages: "25 Pages Biolink",
        seo_feature: "Fonctionnalités SEO",
        brandings: "Brandings",
        customer_support: "Support client 24*7",
      },
      create_page_section: {
        bilbio: "bilbio",
        start_creating_your_exclusive: "Commencez à créer votre exclusif",
        start_creating_your_exclusive_bilbio:
          "Commencez à créer votre exclusif bilbio",
        biolink_url: "URL biolink",
        now: "MAINTENANT",
      },
    },
    about: {
      description_text:
        "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition typographique. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, quand un imprimeur inconnu a pris une galère de type et l'a brouillée pour en faire un spécimen de livre. Il a survécu non seulement à cinq siècles, mais aussi au passage à la composition électronique, restant essentiellement inchangé. Il a été popularisé dans les années 1960 avec la sortie de feuilles Letraset contenant des passages de Lorem Ipsum.",
      description_text_mobile:
        "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition typographique. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, quand un imprimeur inconnu a pris une galère.",
      team: "Équipe",
      meet_our_amazing: "Rencontrez notre incroyable",
      view_all: "Voir tout",
      get_in_touch: "NOUS CONTACTER",
    },
    contact: {
      fill_up_your_contact: "Remplissez vos coordonnées",
      information_and_our_team: "informations et notre équipe",
      will_get_back_to_you: "vous répondra.",
      enter_first_name: "Entrez votre prénom",
      enter_last_name: "Entrez votre nom",
      enter_phone_number: "Entrez votre numéro de téléphone",
      enter_email: "Entrez votre adresse e-mail",
      enter_message_here: "Entrez votre message ici",
      last_name: "Nom de famille",
      phone_number: "Numéro de téléphone",
      enter_valid_number: "Entrez un numéro valide",
      message: "Message",
      last_name_required: "Nom de famille requis",
      phone_number_required: "Numéro de téléphone requis",
      the_email_should_have_less_then_characters:
        "L'e-mail doit avoir moins de 50 caractères",
      message_required: "Champ de message requis",
    },
    pricing: {
      simple_plans_for: "Plans simples pour",
      everyone: "tout le monde",
      have_a_coupon: "Vous avez un coupon?",
      choose_your_plan_get_amazing_discounts_cancel_anytime:
        "Choisissez votre plan. Obtenez des remises incroyables. Annulez à tout moment.",
      free_plan: "Plan gratuit",
      premium_plan_paid: "Plan Premium (Payant)",
    },
    privacy_policy: {
      lorem_ipsum_is_simply_dummy_text_of_the_printing:
        "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition typographique.",
      lorem_ipsum_has_been_the_industry_standard_dummy_text:
        "Lorem Ipsum est le texte factice standard de l'industrie.",
      what_is_lorem_ipsum: "Qu'est-ce que Lorem Ipsum?",
      first_para:
        "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition typographique. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, quand un imprimeur inconnu a pris une galère de type et l'a brouillée pour en faire un spécimen de livre. Il a survécu non seulement à cinq siècles, mais aussi au passage à la composition électronique, restant essentiellement inchangé. Il a été popularisé dans les années 1960 avec la sortie de feuilles Letraset contenant des passages de Lorem Ipsum, et plus récemment avec des logiciels de publication assistée par ordinateur comme Aldus PageMaker, y compris des versions de Lorem Ipsum.",
      second_para:
        "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression et de la composition typographique. Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, quand un imprimeur inconnu a pris une galère de type et l'a brouillée pour en faire un spécimen de livre. Il a survécu non seulement à cinq siècles, mais aussi au passage à la composition électronique, restant essentiellement inchangé. Il a été popularisé dans les années 1960 avec la sortie de feuilles Letraset contenant des passages de Lorem Ipsum",
      li_one:
        "Contrairement à la croyance populaire, Lorem Ipsum n'est pas simplement un texte aléatoire. Il a des racines dans une pièce de littérature latine classique de 45 av. J.-C., ce qui en fait plus de 2000 ans.",
      li_two:
        "Richard McClintock, professeur de latin au Hampden-Sydney College en Virginie, a cherché l'un des mots latins les plus obscurs, consectetur, dans un passage de Lorem Ipsum, et en parcourant les citations du mot dans la littérature classique, a découvert la source indubitable.",
      li_three:
        'Lorem Ipsum provient des sections 1.10.32 et 1.10.33 du "de Finibus Bonorum et Malorum" (Les Extremes du Bien et du Mal) de Cicéron, écrit en 45 av. J.-C.',
      li_four:
        "Ce livre est un traité sur la théorie de l'éthique, très populaire pendant la Renaissance. La première ligne de Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", provient d'une ligne de la section 1.10.32.",
      why_do_we_use_it: "Pourquoi l'utilisons-nous?",
      last_para:
        "Il est établi de longue date qu'un lecteur sera distrait par le contenu lisible d'une page lorsqu'il regardera sa mise en page. L'intérêt d'utiliser Lorem Ipsum est qu'il a une distribution plus ou moins normale des lettres, contrairement à l'utilisation de 'Contenu ici, contenu ici', ce qui donne l'impression d'être lisible en anglais. De nombreux logiciels de PAO et éditeurs de pages Web utilisent désormais Lorem Ipsum comme texte par défaut, et une recherche pour 'lorem ipsum' révélera de nombreux sites Web encore à leurs balbutiements. Plusieurs versions ont évolué au fil des ans, parfois accidentellement, parfois délibérément (humour injecté et similaire).",
    },
  },
  cms: {
    appearance: "Apparence",
    location: "Emplacement",
    profile: "Profil",
    seo: "Seo",
    page: "Page",
    account: "Compte",
    security: "Sécurité",
    billings: "Facturations",
    custom_image: "Image personnalisée",
    maximum: "maximum",
    choose_another: "CHOISIR UN AUTRE",
    select_font: "Sélectionner la police",
    rounded_corners: "Coins arrondis",
    circle: "Cercle",
    full_rounded_corners: "Coins entièrement arrondis",
    straight_corners: "Coins droits",
    outline: "Contour",
    button_background_color: "Couleur de fond du bouton",
    timer_digit_color: "Couleur du chiffre du minuteur",
    timer_background_color: "Couleur de fond du minuteur",
    button_font_color: "Couleur de la police du bouton",
    outline_style: "Style de contour",
    outline_width: "Largeur du contour",
    corners: "coins",
    insert_graph_image: "INSÉRER UNE IMAGE GRAPHIQUE",
    enble_block_search_engine_indexing:
      "Activer l'indexation des moteurs de recherche de blocs",
    page_title_required: "Titre de la page requis",
    meta_description_required: "Description meta requise",
    branding_url_required: "URL de branding requise",
    enter_title: "Entrer le titre",
    enter_url: "Entrer l'URL",
    enter_meta_description: "Entrer la description meta",
    enter_page_title: "Entrer le titre de la page",
    enter_alt_text: "Entrer le texte alternatif",
    hours: "Heures",
    minutes: "Minutes",
    seconds: "Secondes",
    scan_qr_code: "Scanner le code QR",
    cancel: "Annuler",
    you_sure_want_to_logout: "Êtes-vous sûr de vouloir vous déconnecter?",
    previous: "Précédent",
    next: "Suivant",
  },
  appearance: {
    background_cap: "FOND",
    background: "Fond",
    favicon_cap: "FAVICON",
    favicon: "Favicon",
    fonts_cap: "POLICES",
    fonts: "Polices",
    seo_cap: "SEO",
    seo: "Seo",
    avatar_cap: "AVATAR",
    avatar: "Avatar",
    link_cap: "LIEN",
    link: "Lien",
    branding_cap: "BRANDING",
    branding: "Branding",
  },
  contact: {
    name_required: "Le nom est requis",
    only_alphabets: "Seuls les alphabets sont autorisés pour ce champ",
    more_characters: "Le nom ne peut pas dépasser 20 caractères.",
    valid: "L'e-mail doit être valide",
    subject: "Le sujet est requis",
    subject_max: "Le sujet ne peut pas dépasser 30 caractères.",
    message: "Le message est requis",
    message_min: "Le message doit comporter au moins 40 caractères.",
    message_max: "Le message ne peut pas dépasser 250 caractères.",
  },
  descriptions: {
    shorten_urls:
      "Utilisez différentes plateformes en ligne pour interagir avec des individus partageant les mêmes idées, gagner en visibilité et établir une présence numérique pour vos projets créatifs, le tout à partir de votre biolink unique.",
    fully_featured:
      "Système de génération de code QR entièrement équipé avec des modèles faciles à utiliser.",
    update_checkout: "Mise à jour et continuer vers la caisse Golden",
    plans_management: "Gestion des plans",
    create_plan: "Créer un plan",
    no_account: "Vous n'avez pas de compte ?",
    leave_empty: "Laissez vide pour un généré au hasard.",
    scan_qr:
      "Si vous souhaitez activer l'authentification à deux facteurs, scannez le code QR ou entrez la clé secrète dans l'application Google Authenticator et saisissez le code OTP",
    skip: "Ou sautez",
    copy_Qr: "Copiez la clé secrète, c'est confidentiel",
    scanned: "Vérifiez votre e-mail ou Google Authenticator pour le code.",
    do_everything: "Faites tout",
    with_one: "avec un",
    platform: "plateforme",
    get_started: "COMMENCER",
    create_own:
      "Créez votre propre page de biolink unique et hautement personnalisable en toute simplicité.",
    custom_colors: "Couleurs personnalisées et branding",
    ready_to_use: "Plusieurs composants prêts à l'emploi",
    protection:
      "Protection par mot de passe, avertissement de contenu sensible",
    seo_setting: "Paramètres SEO",
    shortened_links: "Liens raccourcis",
    service:
      "Oui ! Vous pouvez utiliser notre service comme raccourcisseur également.",
    demographic: "Ciblage par pays, appareil et langue",
    scheduling: "Planification et limites d'expiration",
    ab_rotation: "Rotation A/B",
    password: "Protection par mot de passe, avertissement de contenu sensible",
    built_in: "Analyses intégrées",
    generate_links:
      "Générez des liens dynamiques vers des fichiers et bénéficiez du suivi, de la protection, des pixels et des fonctionnalités d'expiration.",
    generate_vcard:
      "Générez des liens de vcard dynamiques vers votre carte de contact téléchargeable et bénéficiez du suivi, de la protection, des pixels et des fonctionnalités d'expiration.",
    day_by:
      "Pour les analyses quotidiennes, les références, les pays, les systèmes d'exploitation, les langues et bien d'autres.",
    connect:
      "Connectez votre propre domaine ou utilisez nos domaines prédéfinis.",
    easiest_way:
      "Le moyen le plus simple de catégoriser vos ressources gérées.",
    offering:
      "Nous vous offrons également un ensemble de 35 outils web utiles en bonus.",
    choose_yourself:
      "Choisissez et obtenez exactement ce dont vous avez besoin.",
    feel_free: "N'hésitez pas à nous contacter",
    enter_message: "Saisissez votre message ici.",
    add_multiple_images: "Ajouter plusieurs images",
    add_link: "Ajouter un bouton de lien",
    add_new: "Ajouter un nouveau bloc",
    add_heading: "Ajouter un titre",
    add_avatar: "Ajouter un avatar",
    add_social: "Ajouter des liens sociaux",
    choose_custom_plan: "Commencez le plan Golden",
    almost_there: "Vous y êtes presque, aucune obligation.",
    trial_start: "Commencer mon essai de 7 jours",
    skip_trial: "Ignorer l'essai",
    trial_info:
      "En continuant votre commande, vous confirmez avoir lu, compris et accepté les conditions du site.",
    terms: "Conditions générales",
    add_image: "Ajouter une image",
    img_description:
      "Description de l'image à des fins d'accessibilité et de référencement.",
    add_youtube: "Ajouter une vidéo YouTube",
    paste_video_url:
      "Collez l'URL de votre vidéo YouTube et nous l'afficherons comme une vidéo sur votre profil.",
    add_tiktok: "Ajouter une vidéo TikTok",
    tiktok_url: "URL de la vidéo TikTok",
    valid_email: "L'e-mail doit être une adresse e-mail valide",
    distination_Url: "URL de destination",
    email_required: "L'e-mail est requis",
    password_required: "Le mot de passe est requis",
    name_required: "Le nom est requis",
    user_name_required: "Le nom d'utilisateur est requis",
    firstName_required: "Le prénom est requis",
    firstName_must_alphabets: "Le prénom ne doit contenir que des alphabets.",
    lastName_must_alphabets:
      "Le nom de famille doit contenir uniquement des alphabets.",
    enter_email:
      "Veuillez entrer l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    already_account: "Vous avez déjà un compte ?",
    paste_tiktok: "Partagez l'URL de votre vidéo TikTok",
    drag_drop: "Faites glisser et déposez pour réorganiser",
    can_confirm: "Je confirme avoir lu et compris les",
    of_site: "du site.",
    confirm_password: "Confirmer le nouveau mot de passe",
    confirm_new: "La confirmation du mot de passe est requise",
    field_required: "Champ requis",
    add_instagram: "Ajouter un post Instagram",
    entered_url: "L'URL que vous avez saisie est invalide pour l'intégration",
    least_characters: "Le mot de passe doit comporter au moins 6 caractères",
    must_match: "Les mots de passe doivent correspondre",
    check_email: "Veuillez vérifier votre e-mail !",
    sent_code:
      "Nous avons envoyé un code de confirmation à 6 chiffres à acb@domain, veuillez saisir le code dans la case ci-dessous pour vérifier votre e-mail.",
    no_code: "Vous n'avez pas de code ?",
    code_required: "Le code est requis",
    checking_email: "Vérification de l'e-mail de l'utilisateur",
    monthly_payment: "Paiement mensuel",
    golden_plan: "Plan Golden",
    plan_detail:
      "Vous y êtes presque, remplissez le formulaire suivant et passez à la caisse.",
    payment_frequency: "Fréquence de paiement",
    annual_payments: "Paiements annuels",
    lifetime_deal: "Offre à vie",
    payment_method: "Moyen de paiement",
    payment_method_stripe: "Paiement par Stripe",
    type_payment: "Type de paiement",
    stripe: "Stripe",
    one_payment: "Paiement unique",
    recurring_payment: "Paiement récurrent",
    order_summary: "Résumé de la commande",
    plan: "Plan",
    golden: "Golden",
    frequency: "Fréquence",
    monthly: "Mensuel",
    type: "Type",
    one_time: "Une fois",
    paid_with: "Payé avec",
    pay_pal: "PayPal",
    price: "Prix",
    code_redeemable: "J'ai un code de réduction/utilisable",
    code: "Code",
    total: "Total",
    checkout: "Paiement",
    day: "Tous les 30 jours",
    billing: "Facturation",
    choosen_plan: "Plan choisi",
    home: "Accueil",
    what_get: "Ce que vous obtiendrez",
    one_product: "Un produit final",
    month_update: "12 mois de mises à jour",
    month_support: "6 mois de support",
    bio_pages: "25 pages Biolink",
    bio_block: "10 blocs Biolink",
    all_block: "Tous les blocs Biolink",
    short_link: "250 liens raccourcis",
    file_link: "2 liens vers des fichiers",
    vcard_link: "2 liens vers des vCards",
    qr_code: "5 codes QR",
    proj: "50 projets",
    pixel: "5 pixels",
    custom_domain: "Domaines personnalisés",
    day_stat: "Retention statistique de 365 jours",
    global_domain: "Domaines globaux supplémentaires",
    back_half: "Arrière de page personnalisé",
    deep_lnk: "Deep linking",
    removable_brand: "Marque amovible",
    custom_back: "Arrière-plans personnalisés",
    custom_col: "Couleurs personnalisées",
    defollow: "Liens en Dofollow",
    leap_link: "Lien de saut",
    seo_feature: "Fonctionnalités SEO",
    extra_font: "Polices supplémentaires",
    add_tweet: "Ajouter un Tweet",
    custome_css: "CSS personnalisé",
    custom_js: "JS personnalisé",
    no_ad: "Pas de publicités",
    api_access: "Accès API",
    fill: "Remplissez vos coordonnées de facturation",
    handling:
      "Nous avons besoin de vos coordonnées de facturation pour générer des factures appropriées et pour la gestion fiscale, fournissez uniquement des coordonnées de facturation valides.",
    user_manag: "Gestion des utilisateurs",
    user_logs: "Journaux des utilisateurs",
    user_creat: "Créer un utilisateur",
    set_2fa: "Configurer l'authentification à deux facteurs",
    user: "Utilisateur",
    showout_result: "Affichage des résultats",
    status: "Statut",
    applied_codes: "Codes appliqués",
    applied_taxes: "Taxes appliquées",
    detail: "Détails",
    bulk_actions: "Actions groupées",
    hidden_demo: "Caché en démo",
    cant_undone: " ne peut pas être annulé.",
    login_thisuser: "Se connecter en tant que cet utilisateur",
    loginmodal_detail1:
      "En vous connectant en tant qu'un autre utilisateur, vous serez déconnecté du",
    loginmodal_detail2:
      "compte actuel et entièrement connecté à cet utilisateur.",
    show_result: "Affichage de 1 à 12 sur 12 résultats.",
    total_sales: "Ventes totales",
    visitors: "Visiteurs",
    page_views: "Vues de page",
    paste_instagram_url: "Collez l'URL d'une publication Instagram",
    delete_block_des:
      "Toutes les données liées au bloc biolink seront complètement supprimées. Cette action ne peut pas être annulée.",
    duplicate_block_des:
      "Dupliquez facilement cette ressource en un clic sur un bouton.",
    delete_block: "Supprimer le bloc",
    duplicate_block: "Dupliquer le bloc",
    total_amount: "Montant total",
    admin_privileges:
      "Les utilisateurs administrateurs auront les mêmes privilèges que vous, faites attention !",
    change_passDetail:
      "Laissez-le vide si vous ne souhaitez pas changer le mot de passe de l'utilisateur !",
    new_pass: "Nouveau mot de passe",
    repeat_pass: "Répéter le mot de passe",
    block_search: "Bloquer l'indexation des moteurs de recherche",
    block_biolink:
      "Empêchez votre page biolink d'être indexée par les moteurs de recherche.",
    change_page:
      "Changez complètement le titre de la page par un titre personnalisé que vous définissez ici.",
    custom_meta:
      "Définissez une méta-description personnalisée pour votre page biolink afin de mieux référencer les moteurs de recherche.",
  },
  admin: {
    welcome: "Bienvenue de retour",
    biolink_pages: "Pages Biolink",
    pageviews_tracked: "Pageviews suivis",
  },

  label: {
    view_user: "Voir l'utilisateur",
    privileges: "Privilèges",
    timezone: "Fuseau horaire",
    Factor_authentication: "Authentification à deux facteurs",
    Factor_authentication_2: "Authentification à 2 facteurs",
    Anti_code: "Code anti-hameçonnage",
    active: "Actif",
    english: "Anglais",
    no: "Non",
    api_key: "Clé API",
    total_logins: "Connexions totales",
    last_useragent: "Dernier agent utilisateur",
    last_active: "Dernière activité",
    country: "Pays",
    direct_signup: "Inscription directe",
    source: "Source",
    trial_done: "L'essai est terminé",
    last_subid: "Dernier identifiant d'abonnement",
    last_payamount: "Dernier montant de paiement",
    last_payprocessor: "Dernier processeur de paiement",
    plan_expdate: "Date d'expiration du plan",
    free: "Gratuit",
    disabled: "Désactivé",
    hidden: "Caché",
    arabic: "Arabe",
    main_language: "Langue principale",
    add_tweet: "Ajouter un Tweet",
    update: "Mettre à jour",
    change_password: "Changer le mot de passe",
    enable_stripepay: "Activer les paiements Stripe",
    publishable_key: "Clé publiable",
    secret_key: "Clé secrète",
    webhook_secret: "Secret du webhook",
    webhook: "Webhook",
    more_detail:
      " pour obtenir plus de détails sur certaines configurations disponibles.",
    read_the: "Lisez le",
    documentation: "Documentation",
  },

  addBlock: {
    choose_avatar: "CHOISIR UN AVATAR",
    essentials: "ESSENTIELS",
    text: "TEXTE",
    media: "MÉDIA",
    miscellaneous: "DIVERS",
    addBlocks: "Ajouter des blocs",
    viewBlock: "Voir le bloc",
    paymentDetails: "Détails de paiement",
    renewal: "Renouvellement",
    inclusive_tax: "Taxe incluse",
    apply: "APPLIQUER",
    plan: "Plan",
    enter_coupon_code: "Entrer le code coupon",
    set_up_your: "CONFIGUREZ VOTRE",
    credit_debit_card: "CARTE DE CRÉDIT/DÉBIT",
    card_number: "Numéro de carte",
    card_number_is_required: "Le numéro de carte est requis",
    please_enter_valid_card_number: "Veuillez saisir un numéro de carte valide",
    please_enter_valid_cvv_number: "Veuillez saisir un CVV valide",
    expiry_date_is_required: "La date d'expiration est requise",
    expiry_date: "Date d'expiration",
    enter_valid_month: "Saisissez un mois valide",
    enter_valid_year: "Saisissez une année valide",
    expiry_date_valid_month_year: "Saisissez une date d'expiration valide",
    cvv_is_required: "Le CVV est requis",
    invalid_characters_in_name: "Caractères invalides dans le nom",
    change: "CHANGER",
    renew_plan_automatically:
      "Renouveler automatiquement le plan à la fin de chaque mois. Annulez à tout moment.",
    make_payment: "FAIRE LE PAIEMENT",
    subscribe_start_customizing:
      "Abonnez-vous et commencez la personnalisation",
    your_biolink_now: "de votre Biolink MAINTENANT !",
    year: "Année",
    month: "Mois",
    annual: "Annuel",
    off: "Réduction",
    auto: "Automatique",
    payment_successful: "Paiement réussi",
    enjoy: "PROFITEZ DE",
    using_premium_and_continue: "l'utilisation Premium et continuez à créer",
    exclusive_biolinks: "Biolinks exclusifs",
    page: "Page",
    account: "Compte",
    account_: "COMPTE",
    security: "Sécurité",
    billings: "Facturations",
    setting: "Paramètres",
    page_name: "NOM DE LA PAGE",
    update_your_page_name:
      "Mettez à jour le nom de votre page pour créer votre identité unique.",
    save_changes: "ENREGISTRER LES MODIFICATIONS",
    page_name_cannot: "Le nom de la page ne peut pas contenir de symboles",
    remove: "SUPPRIMER",
    personal_details: "Détails personnels",
    first_name_must_be_valid: "Le prénom doit être un nom valide",
    first_name_must_be_20_characters:
      "Le prénom doit comporter au plus 20 caractères",
    email_should_be_50_characters:
      "L'e-mail doit comporter au plus 50 caractères",
    email_address_must_be_valid:
      "L'adresse e-mail doit être une adresse valide",
    upload: "TÉLÉCHARGER",
    choose_account_type: "Choisir le type de compte",
    enter_country: "Entrer le pays",
    state_region: "État/Région",
    enter_state_region: "Entrer l'État/Région",
    enter_city: "Entrer la ville",
    zip_code: "Code postal",
    enter_zip_code: "Entrer le code postal",
    account_type_required: "Type de compte requis",
    country_required: "Pays requis",
    State_region_required: "État/Région requis",
    city_required: "Ville requise",
    zip_required: "Code postal requis",
    image_smaller_than_3MB: "L'image doit être inférieure à 3 Mo",
    please_select_picture: "Veuillez sélectionner une image",
    image_size_should_be_3mb:
      "La taille de l'image ne doit pas dépasser 3 Mo. Fichiers autorisés .jpeg et .png.",
    security_: "SÉCURITÉ",
    enter_password_twice:
      "Saisissez le nouveau mot de passe deux fois pour le changer",
    new_password: "Nouveau mot de passe",
    password_must_8_characters:
      "Le mot de passe doit contenir au moins 8 caractères",
    including_uppercase_letter:
      "y compris 1 lettre majuscule, 1 lettre minuscule, 1 caractère spécial et 1 valeur numérique",
    enter_new_password: "Saisissez le nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    password_confirmation_required: "Confirmation du mot de passe requise",
    passwords_not_match: "Les mots de passe ne correspondent pas",
    enter_confirm_password: "Saisissez la confirmation du mot de passe",
    factor_authentication_description:
      "Si vous souhaitez activer l'authentification à deux facteurs, scannez le code QR ou saisissez la clé secrète dans l'application Google Authenticator et saisissez le code OTP",
    choose_plan_description: "Choisissez un plan qui correspond à vos besoins",
    billing_history: "HISTORIQUE DE FACTURATION",
    date_joined: "Date d'inscription",
    last_activity: "Dernière activité",
    annually: "Annuellement",
    header: "En-tête",
    add_header: "AJOUTER UN EN-TÊTE",
    enter_page_name: "Entrer le nom de la page",
    enter_page_title: "Entrer le titre de la page",
    pagename_required: "Le nom de la page est requis",
    pagetitle_required: "Le titre de la page est requis",
    contact_required: "Le contact est requis",
    edit_header: "MODIFIER L'EN-TÊTE",
    whatapp_required: "WhatsApp est requis",
    whatapp: "WhatsApp",
    profile_alignment: "ALIGNEMENT DU PROFIL",
    left: "Gauche",
    center: "Centre",
    right: "Droite",
    want_to_set_background_image: "VOUS VOULEZ DÉFINIR L'IMAGE D'ARRIÈRE-PLAN",
    avatar_size: "TAILLE DE L'AVATAR",
    avatar_shape: "FORME D'AVATAR",
    avatar_outline: "APERÇU DE L'AVATAR",
  },
  enter: "Entrer",
  media: "Média",
  link_URL_must_start: "L'URL du lien doit commencer par http:// ou https://",
  link_icon_required: "Icône du lien requise",
  link_url_required: "URL du lien requise",
  link_is_required: "Le titre du lien est requis",
  add_icon: "AJOUTER UNE ICÔNE",
  enter_link: "Entrer le lien",
  enter_link_title: "Entrer le titre du lien",
  custom_link: "LIEN PERSONNALISÉ",
  add_image_grid: "Ajouter une grille d'images",
  header_required: "En-tête requis",
  enter_header: "Entrer l'en-tête",
  header_size: "Taille de l'en-tête",
  header_: "En-tête",
  question_required: "Question requise",
  answer_required: "Réponse requise",
  enter_question: "Entrer la question",
  enter_answer: "Entrer la réponse",
  choose_time: "Choisir l'heure",
  choose_date: "Choisir la date",
  drop_your_img: "Déposez votre image ici ou",
  browse_image: "PARCOURIR L'IMAGE",
  save: "Enregistrer",
  components: "Composants",
  payments: "Paiements",
  terms_here: "Vos conditions de service vont ici",
  bold: "Gras",
  user_id: "Identifiant de l'utilisateur",
  italic: "Italique",
  underline: "Souligné",
  changelog_config:
    " Assurez-vous de reconfigurer les paramètres de vos plans pour la nouvelle configuration des domaines supplémentaires",
  initial_release: "Version initiale",
  changelog_detail:
    "Toutes les mises à jour de Bil Bio seront répertoriées ici. La numérotation des versions de Bil Bio est basée sur le système MAJEUR.MINEUR.PATCH",
  get_support: "Obtenir du support",
  support_is: "Le support est ",
  only: "seulement",
  done_codecanyon: "effectué via le",
  email_form: "formulaire de courrier électronique",
  comments: "commentaires",
  section: "section",
  changelog: "Journal des modifications",
  edit_home: "Modifier la page d'accueil",
  home_settings: "Paramètres de la page d'accueil",
  docs: "Docs",
  read_documentation: "Lire la documentation",
  read_changelog: "Lire le journal des modifications",
  latest_users: "Derniers utilisateurs",
  page_views: "Vues de la page",
  biolinks_pages: "Pages Biolinks",
  authenticate: "Authentifier",
  auth_type: "Type d'authentification",
  time_based: "Basé sur le temps",
  secret_key: "Clé secrète",
  availabe_plan: "Pendant combien de jours le plan sera-t-il disponible",
  code_usage: "Combien de fois le code peut-il être utilisé",
  percent_disc: "Remise en pourcentage",
  fix_discount: "Remise en montant fixe",
  discount_amount: "Montant de la remise",
  percent_amount: "Montant en pourcentage",
  duration: "Durée",
  once: "une fois",
  forever: "pour toujours",
  repeating: "répétitif",
  number_ofmonths: "Nombre de mois",
  months: "mois",
  currency: "Devise",
  redeemable: "Remboursable",
  install_product: "Comment installer le produit ?",
  update_product: "Comment mettre à jour le produit ?",
  customize_product: "Comment personnaliser le produit ?",
  meta_description: "Méta-description",
  title: "Titre",
  statistics: "Statistiques",
  opengraph_image: "Image OpenGraph",
  page_title: "Titre de la page",
  countdown: "Compte à rebours",
  personal: "Personnel",
  business: "Entreprise",
  city: "Ville",
  country: "Pays",
  province: "Province",
  zip: "Code postal",
  resend_code: "Renvoyer le code",
  yes: "Oui",
  choose_plan: "Choisir le plan",
  choose_plan_cap: "CHOISIR LE PLAN",
  home: "Accueil",
  social: "Social",
  whatYouWillGet: "Ce que vous obtiendrez",
  and: "et",
  links_statistics: "Statistiques des liens",
  oftheSite: "du site",
  link: "Lien",
  link_cap: "LIEN",
  telephone: "Téléphone",
  register: "S'inscrire",
  facebook: "Facebook",
  google: "Google",
  tracking_pixels: "Pixels de suivi",
  tool: "Outil",
  block: "Bloc",
  instagram: "Instagram",
  twitter: "Twitter",
  username: "Nom d'utilisateur",
  add: "Ajouter",
  add_cap: "AJOUTER",
  short_url: "URL courte",
  customization: "Personnalisation",
  channel: "Chaîne",
  branding: "Marque",
  fonts: "Polices",
  submit: "Soumettre",
  tracked_reviews: "Vues de pages suivies",
  delete: "Supprimer",
  duplicate: "Dupliquer",
  monochrome: "Monochrome",
  gradient: "Dégradé",
  custom: "Personnalisé",
  themes: "Thèmes",
  background: "Arrière-plan",
  simple_gradients: "Dégradés simples",
  abstract_gradients: "Dégradés abstraits",
  custom_color: "Couleur personnalisée",
  faq: "FAQ",
  color: "Couleur",
  colors: "Couleurs",
  custom_image_video: "Image/Vidéo personnalisée",
  favicon: "Favicon",
  share: "Partager",
  image_alt: "Texte alternatif de l'image",
  maximum: ".png, .gif, .ico autorisés. Maximum 2 Mo.",
  display: "Affichage",
  total_earned: "Total gagné",
  name: "Nom",
  Unique_user_name: "Nom d'utilisateur unique",
  firstName: "Prénom",
  text_color: "Couleur du texte",
  default_branding: "Laissez vide pour la marque du site par défaut.",
  size: "Taille",
  shape: "Forme",
  instagram_url: "URL de la publication Instagram",
  border_radius: "Rayon de la bordure",
  youtube_url: "URL de la vidéo YouTube",
  total: "Total",
  biolinks: "Biolinks",
  biolink: "Biolink",
  files: "Fichiers",
  file: "Fichier",
  biolink_blocks: "Blocs Biolink",
  card: "Carte",
  destination_url: "URL de destination",
  codes: "Codes",
  domains: "Domaines",
  create: "Créer une taxe",
  links: "Liens",
  copyright: "Droits d'auteur",
  terms_of_service: "Conditions d'utilisation",
  views: "vues",
  privacy_policy: "Politique de confidentialité",
  overview: "Aperçu",
  needed_docs:
    "Sur cette page, vous pouvez trouver la documentation nécessaire pour installer et configurer pleinement le produit",
  product_installation:
    " La procédure d'installation du produit est simple et ne nécessite aucune tâche spéciale / hors du commun. Une connaissance minimale de la manière de travailler avec une base de données et de gérer des fichiers sur un serveur est requise",
  policy_here: "Votre politique de confidentialité va ici",
  requirements: "Exigences",
  meet_req:
    " Assurez-vous que votre serveur répond aux exigences suivantes avant d'essayer d'installer ou d'acheter le produit.",
  created_on: "Créé le",
  extensions: "Extensions",
  database: "Base de données",
  server: "Serveur",
  other_extentions:
    "Gardez à l'esprit que d'autres extensions autres que celles mentionnées ici pourraient être nécessaires, car ces exigences supposent que vous utilisez un serveur décent et à jour qui devrait avoir les extensions de base requises déjà fonctionnelles.",
  find_me:
    "Je construis des logiciels de haute qualité, prêts à l'emploi et abordables. Voici où vous pouvez me trouver :",
  december: "Décembre",
  twitter_bilBio: "Twitter @BilBio",
  official_website: "Site web officiel",
  who_are_we: "Qui sommes-nous ?",
  all_rights_reserved: "Tous droits réservés",
  export_to: "Exporter vers",
  filter: "Filtrer",
  search: "Rechercher",
  search_by: "Rechercher par",
  status: "Statut",
  project: "Projet",
  type: "Type",
  order_type: "Type de commande",
  results_per_page: "Résultats par page",
  your_custom_alias: "votre-alias-personnalisé",
  mode: "Mode",
  contrast: "Contraste",
  direction: "Direction",
  layout: "Disposition",
  presets: "Préréglages",
  stretch: "Étirer",
  fullscreen: "Plein écran",
  exit: "Quitter",
  pricing_plans: "Plans tarifaires",
  monthly: "Mensuel",
  annual: "Annuel",
  life_time: "À vie",
  address: "Adresse",
  phone: "Téléphone",
  send_message: "ENVOYER UN MESSAGE",
  email: "E-mail",
  subject: "Sujet",
  heading: "Titre",
  text_editor: "Éditeur de texte",
  avatar: "Avatar",
  socials: "Réseaux sociaux",
  linkedin: "LinkedIn",
  snapchat: "SnapChat",
  twitch: "Twitch",
  spotify: "Spotify",
  image: "Image",
  pinterest: "Pinterest",
  youtube: "YouTube",
  tiktok: "TikTok",
  about_section: "Paramètres de la section À propos",
  contact_settings: "Paramètres de contact",
  Biolink_Page: "Page Biolink",
  Qr_code: "Code QR",
  analytics: "Analytics intégrés",
  destination: "Destination",
  purchased_Plan_monthly: "Vous avez acheté un plan mensuel.",
  purchased_Plan_yearly: "Vous avez acheté un plan annuel.",
  purchased_Plan_lifetime: "Vous avez acheté un plan à vie",
  enjoy_your_plan: "Veuillez profiter de votre plan à vie.",
  close: "Fermer",
  want_to_update_plan_yearly_lifetime:
    "Voulez-vous mettre à jour votre plan Annuel ou à Vie ?",
  want_to_update_plan_lifetime: "Voulez-vous mettre à jour votre plan à Vie ?",
  updating_plan: "Mise à jour du plan",
  powered_by: "Propulsé par",
  text: "Texte",
  round: "Rond",
  rounded: "Arrondi",
  straight: "Droit",
  solid: "Solide",
  dashed: "Pointillé",
  double: "Double",
  outset: "Extérieur",
  inset: "Intérieur",
  border_width: "Largeur de la bordure",
  border_color: "Couleur de la bordure",
  border_style: "Style de la bordure",
  infinite: "Infini",
  bg_color: "Couleur de l'arrière-plan",
  animation: "Animation",
  animation_runs: "Nombre d'animations",
  bounce: "Saut",
  tada: "Tada",
  wobble: "Secouer",
  swing: "Balancer",
  rubberband: "Bande en caoutchouc",
  pulse: "Pulsation",
  flash: "Flash",
  bounce_in: "Sauter à l'intérieur",
  fade_in: "Fondu à l'intérieur",
  small: "Petit",
  medium: "Moyen",
  large: "Grand",
  img_thumbnail: "Image miniature",
  email_address: "Adresse e-mail",
  pass: "Mot de passe",
  forgot_password: "Mot de passe oublié ?",
  forgot_desc: "Pas de soucis ! Ça arrive.",
  forgot_description:
    "Veuillez entrer l'adresse e-mail associée à votre compte.",
  login: "Connexion",
  remember_me: "Se souvenir de moi",
  send_request: "Envoyer la demande",
  back: "Retour",
  dashboard: "Tableau de bord",
  plans: "Plans",
  taxes: "Taxes",
  website_settings: "Paramètres du site web",
  languages: "Langues",
  language_code: "Code de langue",
  verify: "Vérifier",
  tweet_id: "ID du tweet",
  divider: "Séparateur",
  add_divider: "AJOUTER UN SÉPARATEUR",
  seo: "SEO",
  image_grid: "Grille d'images",
  codes_management: "Gestion des codes",
  create_tax: "Créer une taxe",
  redeemed: "Racheté",
  quantity: "Quantité",
  discount: "Remise",
  tax: "Taxe",
  billing_for: "Facturation pour",
  taxes_management: "Gestion des taxes",
  random_discription: "Une description aléatoire pour des frais de support.",
  personal_business: "Personnel et professionnel",
  exclusive: "Exclusif",
  support_fee: "Frais de support",
  call_to_action: "Appel à l'action",
  language: "Langue",
  users: "Utilisateurs",
  add_plan: "Ajouter un plan",
  interval_count: "Nombre d'intervalles",
  interval: "Intervalle",
  trial_days: "Jours d'essai",
  year: "an",
  month: "mois",
  countries: {
    afghanistan: "🇦🇫 Afghanistan",
    aland_islands: "🇦🇽 Îles Åland",
    albania: "🇦🇱 Albanie",
    algeria: "🇩🇿 Algérie",
    american_samoa: "🇦🇸 Samoa américaines",
    andorra: "🇦🇩 Andorre",
    angola: "🇦🇴 Angola",
    anguilla: "🇦🇮 Anguilla",
    antarctica: "🇦🇶 Antarctique",
    antigua_barbuda: "🇦🇬 Antigua-et-Barbuda",
    argentina: "🇦🇷 Argentine",
    armenia: "🇦🇲 Arménie",
    aruba: "🇦🇼 Aruba",
    australia: "🇦🇺 Australie",
    austria: "🇦🇹 Autriche",
    azerbaijan: "🇦🇿 Azerbaïdjan",
    bahamas: "🇧🇸 Bahamas",
    bahrain: "🇧🇭 Bahreïn",
    bangladesh: "🇧🇩 Bangladesh",
    barbados: "🇧🇧 Barbade",
    belarus: "🇧🇾 Biélorussie",
    belgium: "🇧🇪 Belgique",
    belize: "🇧🇿 Belize",
    benin: "🇧🇯 Bénin",
    bermuda: "🇧🇲 Bermudes",
    bhutan: "🇧🇹 Bhoutan",
    bolivia: "🇧🇴 Bolivie",
    eustatius_saba: "🇧🇶 Bonaire, Saint-Eustache et Saba",
    bosnia_herzegovina: "🇧🇦 Bosnie-Herzégovine",
    botswana: "🇧🇼 Botswana",
    bouvet_island: "🇧🇻 Île Bouvet",
    brazil: "🇧🇷 Brésil",
    british_indian: "🇮🇴 Territoire britannique de l'océan Indien",
    brunei_darussalam: "🇧🇳 Brunéi Darussalam",
    bulgaria: "🇧🇬 Bulgarie",
    burkina_faso: "🇧🇫 Burkina Faso",
    burundi: "🇧🇮 Burundi",
    cambodia: "🇰🇭 Cambodge",
    cameroon: "🇨🇲 Cameroun",
    canada: "🇨🇦 Canada",
    cape_verde: "🇨🇻 Cap-Vert",
    cayman_islands: "🇰🇾 Îles Caïmans",
    central_african: "🇨🇫 République centrafricaine",
    chad: "🇹🇩 Tchad",
    chile: "🇨🇱 Chili",
    china: "🇨🇳 Chine",
    christmas_island: "🇨🇽 Île Christmas",
    cocos_islands: "🇨🇨 Îles Cocos (Keeling)",
    colombia: "🇨🇴 Colombie",
    comoros: "🇰🇲 Comores",
    congo: "🇨🇬 Congo",
    democratic_republic: "🇨🇩 République démocratique du Congo",
    cook_islands: "🇨🇰 Îles Cook",
    costa_rica: "🇨🇷 Costa Rica",
    cote_ivoire: "🇨🇮 Côte d'Ivoire",
    croatia: "🇭🇷 Croatie",
    cuba: "🇨🇺 Cuba",
    curacao: "🇨🇼 Curaçao",
    cyprus: "🇨🇾 Chypre",
    czech_republic: "🇨🇿 République tchèque",
    denmark: "🇩🇰 Danemark",
    djibouti: "🇩🇯 Djibouti",
    dominica: "🇩🇲 Dominique",
    dominican_republic: "🇩🇴 République dominicaine",
    ecuador: "🇪🇨 Équateur",
    egypt: "🇪🇬 Égypte",
    el_salvador: "🇸🇻 Salvador",
    equatorial_guinea: "🇬🇶 Guinée équatoriale",
    eritrea: "🇪🇷 Érythrée",
    estonia: "🇪🇪 Estonie",
    ethiopia: "🇪🇹 Éthiopie",
    falkland_islands: "🇫🇰 Îles Falkland (Malouines)",
    faroe_islands: "🇫🇴 Îles Féroé",
    fiji: "🇫🇯 Fidji",
    finland: "🇫🇮 Finlande",
    france: "🇫🇷 France",
    french_guiana: "🇬🇫 Guyane française",
    french_polynesia: "🇵🇫 Polynésie française",
    southern_territories: "🇹🇫 Terres australes françaises",
    gabon: "🇬🇦 Gabon",
    gambia: "🇬🇲 Gambie",
    georgia: "🇬🇪 Géorgie",
    germany: "🇩🇪 Allemagne",
    ghana: "🇬🇭 Ghana",
    gibraltar: "🇬🇮 Gibraltar",
    greece: "🇬🇷 Grèce",
    greenland: "🇬🇱 Groenland",
    grenada: "🇬🇩 Grenade",
    guadeloupe: "🇬🇵 Guadeloupe",
    guam: "🇬🇺 Guam",
    guatemala: "🇬🇹 Guatemala",
    guernsey: "🇬🇬 Guernesey",
    guinea: "🇬🇳 Guinée",
    guinea_bissau: "🇬🇼 Guinée-Bissau",
    guyana: "🇬🇾 Guyana",
    haiti: "🇭🇹 Haïti",
    heard_island: "🇭🇲 Île Heard et îles McDonald",
    holy_see: "🇻🇦 Saint-Siège (État de la Cité du Vatican)",
    honduras: "🇭🇳 Honduras",
    hong_kong: "🇭🇰 Hong Kong",
    hungary: "🇭🇺 Hongrie",
    iceland: "🇮🇸 Islande",
    india: "🇮🇳 Inde",
    indonesia: "🇮🇩 Indonésie",
    iran_islamic: "🇮🇷 Iran, République islamique d'",
    iraq: "🇮🇶 Irak",
    ireland: "🇮🇪 Irlande",
    isle_man: "🇮🇲 Île de Man",
    israel: "🇮🇱 Israël",
    italy: "🇮🇹 Italie",
    jamaica: "🇯🇲 Jamaïque",
    japan: "🇯🇵 Japon",
    jersey: "🇯🇪 Jersey",
    jordan: "🇯🇴 Jordanie",
    kazakhstan: "🇰🇿 Kazakhstan",
    kenya: "🇰🇪 Kenya",
    kiribati: "🇰🇮 Kiribati",
    korea_democratic: "🇰🇵 Corée, République démocratique populaire de",
    korea_republic: "🇰🇷 Corée, République de",
    kosovo: "🇽🇰 Kosovo",
    kuwait: "🇰🇼 Koweït",
    kyrgyzstan: "🇰🇬 Kirghizistan",
    lao_people: "🇱🇦 Laos, République démocratique populaire",
    latvia: "🇱🇻 Lettonie",
    lebanon: "🇱🇧 Liban",
    lesotho: "🇱🇸 Lesotho",
    liberia: "🇱🇷 Libéria",
    libyan_arab: "🇱🇾 Jamahiriya arabe libyenne",
    liechtenstein: "🇱🇮 Liechtenstein",
    lithuania: "🇱🇹 Lituanie",
    luxembourg: "🇱🇺 Luxembourg",
    macao: "🇲🇴 Macao",
    macedonia_former: "🇲🇰 Macédoine, ex-République yougoslave de",
    madagascar: "🇲🇬 Madagascar",
    malawi: "🇲🇼 Malawi",
    malaysia: "🇲🇾 Malaisie",
    maldives: "🇲🇻 Maldives",
    mali: "🇲🇱 Mali",
    malta: "🇲🇹 Malte",
    marshall_islands: "🇲🇭 Îles Marshall",
    martinique: "🇲🇶 Martinique",
    mauritania: "🇲🇷 Mauritanie",
    mauritius: "🇲🇺 Maurice",
    mayotte: "🇾🇹 Mayotte",
    mexico: "🇲🇽 Mexique",
    micronesia_federated: "🇫🇲 Micronésie, États fédérés de",
    moldova_republic: "🇲🇩 Moldova, République de",
    monaco: "🇲🇨 Monaco",
    mongolia: "🇲🇳 Mongolie",
    montenegro: "🇲🇪 Monténégro",
    montserrat: "🇲🇸 Montserrat",
    morocco: "🇲🇦 Maroc",
    mozambique: "🇲🇿 Mozambique",
    myanmar: "🇲🇲 Myanmar",
    namibia: "🇳🇦 Namibie",
    nauru: "🇳🇷 Nauru",
    nepal: "🇳🇵 Népal",
    netherlands: "🇳🇱 Pays-Bas",
    netherlands_antilles: "🇦🇳 Antilles néerlandaises",
    new_caledonia: "🇳🇨 Nouvelle-Calédonie",
    new_zealand: "🇳🇿 Nouvelle-Zélande",
    nicaragua: "🇳🇮 Nicaragua",
    niger: "🇳🇪 Niger",
    nigeria: "🇳🇬 Nigéria",
    niue: "🇳🇺 Niue",
    norfolk_island: "🇳🇫 Île Norfolk",
    northern_mariana: "🇲🇵 Îles Mariannes du Nord",
    norway: "🇳🇴 Norvège",
    oman: "🇴🇲 Oman",
    pakistan: "🇵🇰 Pakistan",
    palau: "🇵🇼 Palaos",
    palestinian_territory: "🇵🇸 Territoire palestinien occupé",
    panama: "🇵🇦 Panama",
    papua_new: "🇵🇬 Papouasie-Nouvelle-Guinée",
    paraguay: "🇵🇾 Paraguay",
    peru: "🇵🇪 Pérou",
    philippines: "🇵🇭 Philippines",
    pitcairn: "🇵🇳 Pitcairn",
    poland: "🇵🇱 Pologne",
    portugal: "🇵🇹 Portugal",
    puerto_rico: "🇵🇷 Porto Rico",
    qatar: "🇶🇦 Qatar",
    reunion: "🇷🇪 Réunion",
    romania: "🇷🇴 Roumanie",
    russian_federation: "🇷🇺 Fédération de Russie",
    rwanda: "🇷🇼 Rwanda",
    saint_barthelemy: "🇧🇱 Saint-Barthélemy",
    saint_helena: "🇸🇭 Sainte-Hélène",
    saint_kitts: "🇰🇳 Saint-Christophe-et-Niévès",
    saint_lucia: "🇱🇨 Sainte-Lucie",
    saint_martin: "🇲🇫 Saint-Martin",
    saint_pierre: "🇵🇲 Saint-Pierre-et-Miquelon",
    saint_vincent: "🇻🇨 Saint-Vincent-et-les-Grenadines",
    samoa: "🇼🇸 Samoa",
    san_marino: "🇸🇲 Saint-Marin",
    sao_tome: "🇸🇹 Sao Tomé-et-Principe",
    saudi_arabia: "🇸🇦 Arabie saoudite",
    senegal: "🇸🇳 Sénégal",
    serbia: "🇷🇸 Serbie",
    serbia_montenegro: "🇨🇸 Serbie-et-Monténégro",
    seychelles: "🇸🇨 Seychelles",
    sierra_leone: "🇸🇱 Sierra Leone",
    singapore: "🇸🇬 Singapour",
    sint_maarten: "🇸🇽 Saint-Martin",
    slovakia: "🇸🇰 Slovaquie",
    slovenia: "🇸🇮 Slovénie",
    solomon_islands: "🇸🇧 Îles Salomon",
    somalia: "🇸🇴 Somalie",
    south_africa: "🇿🇦 Afrique du Sud",
    south_georgia: "🇬🇸 Géorgie du Sud et les îles Sandwich du Sud",
    south_sudan: "🇸🇸 Soudan du Sud",
    spain: "🇪🇸 Espagne",
    sri_lanka: "🇱🇰 Sri Lanka",
    sudan: "🇸🇩 Soudan",
    suriname: "🇸🇷 Surinam",
    svalbard_jan: "🇸🇯 Svalbard et l'île Jan Mayen",
    swaziland: "🇸🇿 Eswatini",
    sweden: "🇸🇪 Suède",
    switzerland: "🇨🇭 Suisse",
    syrian_arab: "🇸🇾 République arabe syrienne",
    taiwan_province: "🇹🇼 Taïwan, Province de Chine",
    tajikistan: "🇹🇯 Tadjikistan",
    tanzania_united: "🇹🇿 Tanzanie, République-Unie de",
    thailand: "🇹🇭 Thaïlande",
    timor_leste: "🇹🇱 Timor oriental",
    togo: "🇹🇬 Togo",
    tokelau: "🇹🇰 Tokelau",
    tonga: "🇹🇴 Tonga",
    trinidad_tobago: "🇹🇹 Trinité-et-Tobago",
    tunisia: "🇹🇳 Tunisie",
    turkey: "🇹🇷 Turquie",
    turkmenistan: "🇹🇲 Turkménistan",
    turks_caicos: "🇹🇨 Îles Turks et Caicos",
    tuvalu: "🇹🇻 Tuvalu",
    uganda: "🇺🇬 Ouganda",
    ukraine: "🇺🇦 Ukraine",
    united_arab: "🇦🇪 Émirats arabes unis",
    united_kingdom: "🇬🇧 Royaume-Uni",
    united_states: "🇺🇸 États-Unis",
    unitedStates_minor: "🇺🇲 Îles mineures éloignées des États-Unis",
    uruguay: "🇺🇾 Uruguay",
    uzbekistan: "🇺🇿 Ouzbékistan",
    vanuatu: "🇻🇺 Vanuatu",
    venezuela: "🇻🇪 Venezuela",
    viet_nam: "🇻🇳 Viêt Nam",
    virgin_islands: "🇻🇬 Îles Vierges britanniques",
    islands_us: "🇻🇮 Îles Vierges américaines",
    wallis_futuna: "🇼🇫 Wallis-et-Futuna",
    western_sahara: "🇪🇭 Sahara occidental",
    yemen: "🇾🇪 Yémen",
    zambia: "🇿🇲 Zambie",
    zimbabwe: "🇿🇼 Zimbabwe",
  },
  create_code: "Créer un code",
  create_newCode: "Créer un nouveau code",

  miscellaneous: {
    tweel_url: "Ajouter l'URL du tweet",
    divider: "Séparateur",
    divider_cap: "SÉPARATEUR",
    add_share: "Ajouter un bloc de partage",
    add_countdown: "AJOUTER UN COMPTE À REBOURS",
    edit_countdown: "MODIFIER LE COMPTE À REBOURS",
    enter_countdown_description: "Entrer la description du compte à rebours",
    date_time: "Date et heure",
    add_action: "Ajouter une action",
    add_faq: "Ajouter des questions fréquemment posées (FAQ)",
    email_me: "M'envoyer un e-mail",

    discount_plan: "Choisissez une remise entre 1 % et 99 % pour le code",
    bulk_generator: "Générateur en masse",
  },
  edit_taxes: {
    create_new: "Créer une nouvelle taxe",
    created_tax:
      "Une fois une taxe créée, elle ne peut pas être modifiée ou supprimée. Après la création de la taxe, vous pouvez l'associer à vos plans créés.",
    percentage: "Pourcentage",
    taxes: "Taxes",
    edittax: "Modifier la taxe",
    edit: "Modifier",
    edit_cap: "MODIFIER",
    description: "Description",
    tax_value: "Valeur de la taxe",
    value_type: "Type de valeur",
    fixed: "Fixe",
    inclusive: "Inclusif",
    exclusive: "Exclusif",
    personal_only: "Personnel uniquement",
    business_only: "Professionnel uniquement",
    personal_business: "Personnel et professionnel",
    billing_for: "Facturation pour",
    countries: "Pays",

    select:
      "Sélectionnez les pays auxquels vous souhaitez appliquer cette taxe. Laissez vide si vous souhaitez que la taxe soit appliquée à tous les pays.",
  },

  planss: {
    edit_plan: "Modifier le plan",
    plan_features: "Fonctionnalités du plan",
    set: "Définir",
    for_unlimited: "pour illimité",
    total_amoutpage:
      "Le nombre total de pages de biolink qu'un utilisateur peut créer.",
    total_shortlink:
      "Le nombre total de liens raccourcis qu'un utilisateur peut créer.",
    total_filelink:
      "Le nombre total de liens de fichiers qu'un utilisateur peut créer.",
    vcard_Limit: "Limite de liens Vcard",
    totl_vcard: "Le nombre total de liens vcard qu'un utilisateur peut créer.",
    total_eventlinks:
      "Le nombre total de liens d'événements qu'un utilisateur peut créer.",
    total_domain:
      "Le nombre total de domaines personnalisés qu'un utilisateur peut ajouter.",
    link_state:
      "Pendant combien de jours les statistiques des liens seront-elles conservées dans la base de données.",
    enable_blocks: "Blocs de biolink activés",
    select_blocks:
      "Sélectionnez quels blocs de page biolink sont activés pour l'utilisation sur ce plan.",
    state_retention: "Conservation des statistiques des liens (jours)",
    custom_domain: "Limite de domaines personnalisés",
    event_limit: "Limite de liens d'événements",
    file_limit: "Limite de liens de fichiers",
    link_limit: "Limite de liens",
    blocks_limit: "Limite de blocs biolink par page biolink",
    biolink_limit: "Limites de biolinks",
    qr_limit: "Limites de codes QR",
    pixels_limits: "Limites de pixels",
    project_limits: "Limites de projets",
    additional_block: "Domaines globaux supplémentaires",
    additional_blockDes:
      "Activer cela permettra à toutes les personnes ayant ce plan d'utiliser tous les domaines globaux supplémentaires.",
    back_half: "Demi-arrière personnalisé",
    back_halfDes:
      "Activer cela donnera la possibilité aux utilisateurs d'avoir des alias d'URL personnalisés au lieu de ceux générés automatiquement.",
    deep_link: "Liens profonds",
    deep_linkDes:
      "Activer cela donnera la possibilité à l'utilisateur d'utiliser des liens profonds pour pointer vers des applications spécifiques au lieu de seulement des URL http et https.",
    enable_ad:
      "Activer cela fera en sorte que toutes les personnes ayant ce plan ne voient pas d'annonces.",
    remove_brand: "Marque de pied de page amovible",
    remove_brandDes:
      "Cela donne la possibilité aux utilisateurs de supprimer la marque du pied de page des biolinks.",
    button_url: "URL du bouton de contact",
    description: "Description",
    phone_collector: "Collecteur de numéros de téléphone",
    email_collector: "Collecteur d'adresses e-mail",
    paragraph: "Paragraphe",
    custom_branding: "Marque de pied de page personnalisée",
    custom_brandingDes:
      "Cela donne la possibilité aux utilisateurs d'ajouter leur propre marque personnalisée pour le pied de page des biolinks.",
    colored_links: "Liens colorés",
    colored_linksDes:
      "Donne à l'utilisateur la possibilité de personnaliser la couleur de leurs liens biolinks",
    advanced_statistics: "Statistiques avancées",
    check_stat:
      "Donne à l'utilisateur la possibilité de vérifier des statistiques plus approfondies et de sélectionner la période.",
    custom_backgrounds: "Arrière-plans personnalisés",
    custom_backgroundDes:
      "Donne à l'utilisateur la possibilité d'ajouter des arrière-plans personnalisés sur leurs pages biolinks (couleurs, dégradés et images réelles).",
    temporary_URL: "URL temporaire",
    temporary_urlDes:
      "Donne à l'utilisateur la possibilité de planifier des liens et de limiter les clics.",
    seo_des:
      "Donne à l'utilisateur la possibilité de changer le titre et la méta-description des pages biolink",
    utm_des:
      "Donne à l'utilisateur la possibilité de définir des paramètres UTM globaux pour tous les liens à l'intérieur d'une page biolink.",
    fonts_des:
      "Donne à l'utilisateur la possibilité de choisir une police de caractères de son choix parmi la liste des polices supplémentaires.",
    password_protection: "Protection par mot de passe",
    password_protectionDes:
      "Donne à l'utilisateur la possibilité de protéger ses liens par mot de passe.",
    sensitive_content: "Avertissement de contenu sensible",
    sensitive_contentDes:
      "Donne à l'utilisateur la possibilité d'activer un avertissement de contenu sensible sur ses liens.",
    leap_linkDes:
      "Donne à l'utilisateur la possibilité de rediriger temporairement les pages biolink vers une URL particulière.",
    dofollow_link: "Liens biolink dofollow",
    dofollow_linkDes:
      "Les liens biolink de l'utilisateur auront la propriété dofollow, sinon elle est définie par défaut à nofollow.",
    rest_api:
      "Activer la possibilité pour l'utilisateur d'utiliser l'API REST.",
    customcss_des:
      "Activer la possibilité d'ajouter du CSS personnalisé pour chaque page biolink. Veillez à ne permettre cela qu'aux personnes de confiance.",
    customjs_des:
      "Activer la possibilité d'ajouter du JavaScript personnalisé pour chaque carte de visite. Veillez à ne permettre cela qu'aux personnes de confiance.",
    product_name: "Nom du produit",
    order: "Commande",
    plan_name: "Nom du plan",
    action: "Action",
  },
  filtermodal: {
    all: "Tous",
    unconfirmed: "Non confirmé",
    admin_created: "Créé par l'administrateur",
    admin_api: "Créé par l'administrateur via l'API",
    facebook_login: "Connexion avec Facebook",
    twitter_login: "Connexion avec Twitter",
    discord_login: "Connexion avec Discord",
    google_login: "Connexion avec Google",
    registration_date: "Date d'inscription",
    ascending: "Ascendant",
    descending: "Descendant",
    ten: "2",
    twentyfive: "3",
    fifty: "5",
    hundred: "7",
    twohundred: "10",
    fivehundred: "20",
    filters: "Filtres",
    order_by: "Trier par",
    results_page: "Résultats par page",
    created_datetime: "Date et heure de création",
    redeemable: "Remboursable",
    dayss: "Jours",
    external_payment: "ID de paiement externe",
    paid: "Payé",
    pending: "En attente",
    offline_payment: "Paiement hors ligne",
    coinbase: "Coinbase",
    payU: "PayU",
    paystack: "Paystack",
    razorpay: "Razorpay",
    mollie: "Mollie",
    yookassa: "Yookassa",
    crypto: "Crypto.com",
    paddle: "Paddle",
    monthly_payments: "Paiements mensuels",
    missing_translation:
      "traduction_manquante: administratrice_Paiements.filtres.commande_par_nom",
    missing_translate:
      "traduction_manquante: administratrice_Paiements.filtres.commande_par_e-mail",
  },

  location: {
    addpin: "Ajouter une épingle",
    cancel_adding_pin: "Annuler l'ajout d'une épingle",
    adress: "Adresse",
    adress_placeholder: "123, rue principale, Ville",
    phone: "Téléphone",
    phone_placeholder: "123-456-7890",
    add_location: "Ajouter un lieu",
    set_primary: "Définir comme principal",
    primary_location: "Lieu principal",
    get_directions: "Obtenir des directions",
    added_any_location: "Vous n'avez ajouté aucun emplacement",
    adress_title_caps: "AJOUTER UN TITRE D'ADRESSE",
    adress_details_caps: "AJOUTER DES DÉTAILS D'ADRESSE",
    enter_location_name: "Entrez le nom de l'emplacement",
    enter_location_adress: "Entrez l'adresse de l'emplacement",
    enter_location_phone: "Entrez le téléphone de l'emplacement",
    set_default_location:
      "Définir cet emplacement comme principal / par défaut",
    home: "Accueil",
  },

  language_setting: {
    language_cap: "Langue",
    update_with_unique_identity:
      "Mettez à jour le nom de votre page pour créer votre identité unique",
    added_languge: "Langue ajoutée",
    more_lang_cap: "AJOUTER UNE AUTRE LANGUE",
    english: "Anglais",
    arabic: "Arabe",
    sidebar_language: "Langue",
    french: "Français",
    chinese: "Chinois",
    vietnamese: "Vietnamien",
    search_other_lang: "Rechercher d'autres langues",
    english_default: "Anglais (par défaut)",
  },

  report: {
    report_abuse: "Signaler un abus",
    page_url: "URL de la page",
    enter_page_url: "Entrez l'URL de la page qui est signalée",
    report_type: "Type de signalement",
    reporter_type: "Type de signaleur",
    additional_comment: "Commentaire supplémentaire",
    attachment: "Pièce jointe",
    select_report_type: "Sélectionnez un type de signalement",
    spam_scam_phishing: "Spam, escroquerie ou hameçonnage",
    adult_content: "Contenu pour adultes",
    illegal_goods_services: "Biens et services illégaux",
    fraud: "Fraude",
    child_abuse: "Abus sur mineur",
    shocking_violent_content: "Contenu choquant ou violent",
    privacy_impersonation_harassment:
      "Protection de la vie privée, usurpation et harcèlement",
    gambling: "Jeu d'argent",
    select_reporter_type: "Sélectionnez un type de signaleur",
    bil_bio_user: "Utilisateur Bil Bio",
    non_bil_bio_user: "Utilisateur non Bil Bio",
    legal_representative: "Représentant légal",
    law_enforcement: "Forces de l'ordre",
    regulatory_body: "Organisme de régulation",
    type_report_required: "Le type de signalement est requis",
    type_reporter_required: "Le type de signaleur est requis",
    comment_required: "Un commentaire est requis",
    url_required: "L'URL de la page est requise",
    attachment_required: "Une pièce jointe est requise",
    report_sentence:
      "Avec ce formulaire vous pouvez signaler tout abus du bil bio",
    site_protected: "Ce site est protégé par reCAPTCHA et Google",
    apply: "appliquer",
    your_submission_received: "Votre demande a été reçue!",
    you_will_contacted: "Vous serez contacté si nécessaire.",
    go_home: "RENTRER CHEZ SOI",
  },
  user_analytics: {
    analytics: "Analytique",
    some_states: "Vérifions quelques statistiques aujourd'hui !",
    feature_available: "Cette fonctionnalité est uniquement disponible pour",
    pro_user: "Utilisateurs Pro",
    upgrade: "PASSER À LA VERSION PRO",
    weak: "Faible",
    month: "Mois",
    year: "Année",
    custom_duration: "Durée personnalisée",
    no_visitor: "Nombre de visiteurs",
    no_clicks: "Nombre de clics",
    insta: "Instagram",
    twitter: "Twitter",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    pinterest: "Pinterest",
    facebook: "Facebook",
    visitor_by_day: "Visiteurs par jour et heure",
    sat: "Sam",
    sun: "Dim",
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
  },
  createPassword: {
    title: "Entrez le mot de passe",
    description: "Entrez le mot de passe pour compléter votre compte.",
    password: "Mot de passe",
    enterPassword: "Entrez le mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    enterConfirmPassword: "Entrez la confirmation du mot de passe",
    accountAgreement: "En créant un compte, vous acceptez notre Politique de Confidentialité et nos Conditions Générales.",
    createAccount: "CRÉER UN COMPTE",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    logIn: "SE CONNECTER",
  },
  
  privacy_title: "Votre vie privée est importante pour nous",
  privacy_content:
    "Les cookies sont de très petits fichiers texte qui sont stockés sur votre ordinateur lorsque vous visitez un site web. Nous utilisons des cookies pour diverses raisons et pour améliorer votre expérience en ligne sur notre site web (par exemple, pour mémoriser les détails de connexion de votre compte). Vous pouvez modifier vos préférences et refuser certains types de cookies d'être stockés sur votre ordinateur lors de la navigation sur notre site web. Vous pouvez également supprimer tous les cookies déjà stockés sur votre ordinateur, mais gardez à l'esprit que la suppression des cookies peut vous empêcher d'utiliser certaines parties de notre site web.",
  strictly_necessary_title: "Cookies strictement nécessaires",
  strictly_necessary_content:
    "Ces cookies sont essentiels pour vous fournir des services disponibles sur notre site web et pour vous permettre d'utiliser certaines fonctionnalités de notre site web. Sans ces cookies, nous ne pouvons pas vous fournir certains services sur notre site web.",
  functionality_title: "Cookies de fonctionnalité",
  functionality_content:
    "Ces cookies sont utilisés pour vous fournir une expérience plus personnalisée sur notre site web et pour mémoriser les choix que vous faites lorsque vous utilisez notre site web. Par exemple, nous pouvons utiliser des cookies de fonctionnalité pour mémoriser vos préférences linguistiques ou vos détails de connexion.",
  tracking_title: "Cookies de suivi",
  tracking_content:
    "Ces cookies sont utilisés pour collecter des informations afin d'analyser le trafic vers notre site web et comment les visiteurs utilisent notre site web. Par exemple, ces cookies peuvent suivre des choses comme le temps que vous passez sur le site ou les pages que vous visitez, ce qui nous aide à comprendre comment nous pouvons améliorer notre site web pour vous. Les informations collectées par le biais de ces cookies de suivi et de performance n'identifient aucun visiteur individuel.",
  targeting_advertising_title: "Cookies de ciblage et de publicité",
  targeting_advertising_content:
    "Ces cookies sont utilisés pour afficher des publicités susceptibles de vous intéresser en fonction de vos habitudes de navigation. Ces cookies, servis par nos fournisseurs de contenu et/ou de publicité, peuvent combiner les informations qu'ils ont collectées sur notre site web avec d'autres informations qu'ils ont collectées de manière indépendante concernant les activités de votre navigateur web sur leur réseau de sites web. Si vous choisissez de supprimer ou de désactiver ces cookies de ciblage ou de publicité, vous verrez toujours des publicités, mais elles peuvent ne pas être pertinentes pour vous.",
  more_info_title: "Plus d'informations",
  more_info_content:
    "Pour toute question concernant notre politique en matière de cookies et vos choix, veuillez nous contacter.",

  your_privacy: "Votre vie privée",
  strict_necessary_cookies: "Cookies strictement nécessaires",
  functionality_cookies: "Cookies de fonctionnalité",
  tracking_cookies: "Cookies de suivi",
  targeting_cookies: "Cookies de ciblage et de publicité",
  more_info: "Plus d'informations",
  cookies_preference_center: "Centre de préférences des cookies",
  always_active: "Toujours actif",
  in_active: "Inactif",
  cookies_consent: "Consentement aux cookies par",
  terms_feed: "Conditions de Feed",
  save_my_preferences: "Enregistrer mes préférences",
  active: "Actif",
  read_more: "Lire la suite",
  read_less: "Réduire",

  want_to_delete: "Êtes-vous sûr de vouloir supprimer ceci ?",
  get_started_now: "COMMENCER MAINTENANT",
  join_waiting_list: "Rejoignez une liste d'attente",
  package_suitable_people:
    "Ce forfait convient aux équipes de 1 à 15 personnes.",
  my_location: "Ma position",
  be_the_first_to: "Soyez le premier à",
  bil_bio: "Bil.Bio",
  experience: "expérience",
  waitlist_early_access: "Inscrivez-vous maintenant pour rejoindre la liste d'attente pour un accès anticipé. Faites partie de notre voyage !",
  you_are_waitlist: "Vous êtes sur la liste d'attente !",
  thanks_joining_waitlist: "Merci d'avoir rejoint notre liste d'attente ! Vous serez parmi les premiers informés à mesure que nous nous rapprochons du lancement de notre nouvelle plateforme. Restez à l'écoute des mises à jour et des informations exclusives. Nous sommes ravis de vous avoir parmi nous !",
  main_title_part_one: "Créez un seul lien",
  main_title_part_two: "pour tous tes liens",
  no_blocks_found: "Aucun bloc trouvé !",
  lorem_ipsum_dolor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit urna dictum placerat urna iaculis",
};

export default fr;
